/* eslint-disable global-require */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useLocation } from '@reach/router'
// import { Link } from 'gatsby'

// Libraries
// import CookieConsent from 'react-cookie-consent'
// import CookieBot from 'react-cookiebot'

// Theme
import Theme from 'styles/Theme'

// Components
import Footer from './Footer'
import Header from './Header'

// CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'styles/all.css'

const Content = styled.div`
  @media (min-width: 992px) {
    padding-top: ${(props) =>
      props.isNis2 ? 100 : props.showActionBanner === 't' ? 135 : 100}px;
  }

  @media (max-width: 991px) {
    padding-top: ${(props) =>
      props.isNis2 ? 60 : props.showActionBanner === 't' ? 85 : 50}px;
  }
`

// const CookieLink = styled(Link)`
//   color: ${props => props.theme.color.text.light};
//   text-decoration: underline;
// `

const Layout = ({ children, spacingBottom = false }) => {
  const location = useLocation()
  const isNis2 = location.pathname === '/nis2' || location.pathname.startsWith('/nis2/')
  const [isSticky, setSticky] = useState(false)
  const [showActionBanner, setShowActionBanner] = useState('t')

  const handleScroll = () => {
    setSticky(window.scrollY > 0)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    const showActionBannerLocal = window.localStorage.getItem('action-banner')

    if (showActionBannerLocal) {
      setShowActionBanner(showActionBannerLocal)
    }

    handleScroll()

    return () => {
      window.removeEventListener('scroll', () => handleScroll)
    }
  }, [handleScroll])

  const setShowActionBannerLocal = (value) => {
    window.localStorage.setItem('action-banner', value)

    setShowActionBanner(value)
  }

  return (
    <Theme>
      <Header
        isNis2={isNis2}
        isSticky={isSticky}
        setShowActionBanner={setShowActionBannerLocal}
        showActionBanner={showActionBanner}
      />
      <Content isSticky={isSticky} showActionBanner={showActionBanner} isNis2={isNis2}>
        {children}
      </Content>
      <Footer isNis2={isNis2} spacingBottom={spacingBottom} />
    </Theme>
  )
}

export default Layout
